import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import keyCodes from 'utils/keyCodes';

const STYLE_DISPLAY_INLINE_BLOCK = { display: 'inline-block' };

export default class QuantityInput extends PureComponent {
  static propTypes = {
    analyticsContextData: PropTypes.object,
    isUpdating: PropTypes.bool,
    maxQuantity: PropTypes.number,
    minQuantity: PropTypes.number,
    onQuantitySubmit: PropTypes.func.isRequired,
    productWarning: PropTypes.bool,
    quantity: PropTypes.number,
    className: PropTypes.string,
    showButtons: PropTypes.bool,
  };

  static defaultProps = {
    minQuantity: 0,
    maxQuantity: 99,
    showButtons: true,
    className: 'quantityInput__input fop-in-trolley',
  };

  static getDerivedStateFromProps(nextProps, prevState) {
    const nextQuantity = nextProps.quantity;

    if (nextQuantity !== prevState.quantityProps) {
      return {
        quantity: nextQuantity,
        quantityProps: nextQuantity,
      };
    }

    return null;
  }

  state = {};

  componentDidUpdate() {
    // React does not see the difference between 00002 and 2, therefore we need to update the value ourselves
    if (this.quantityInput) {
      const { quantity } = this.props;
      this.quantityInput.value = quantity && quantity.length ? parseInt(quantity, 10) : quantity;
    }
  }

  onFocus = () => {
    try {
      this.quantityInput.setSelectionRange(0, 3);
    } catch (error) {
      this.quantityInput.select();
    }
  };

  onChange = (event) => {
    const { value: nextQuantity } = event.target;

    if (this.isQuantityInRange(nextQuantity)) {
      this.setState({ quantity: nextQuantity });
    }
  };

  bindInput = (input) => {
    this.quantityInput = input;
  };

  handleKeyPress = (event) => {
    const { key, keyCode } = event;
    if (key === 'Enter' || keyCode === keyCodes.ENTER) {
      this.quantityInput.blur();
    }

    if (!this.isDigitPressed(event)) {
      event.preventDefault();
    }
  };

  isDigitPressed = (event) => {
    const { key, keyCode } = event;
    return /\d/.test(key) || (keyCode >= keyCodes[0] && keyCode <= keyCodes[9]);
  };

  submitQuantityUpdate = (quantityDelta) => {
    const { analyticsContextData } = this.props;
    this.props.onQuantitySubmit(quantityDelta, analyticsContextData);
  };

  isQuantityInRange = (quantity) => {
    const { minQuantity, maxQuantity } = this.props;
    return minQuantity <= quantity && quantity <= maxQuantity;
  };

  handleQuantityInputBlur = () => {
    const { quantity } = this.props;
    const { quantity: nextQuantity } = this.state;

    const quantityDelta = nextQuantity - quantity;

    if (quantityDelta && this.isQuantityInRange(nextQuantity)) {
      this.submitQuantityUpdate(quantityDelta);
    }
  };

  increase = () => {
    this.submitQuantityUpdate(1);
  };

  decrease = () => {
    this.submitQuantityUpdate(-1);
  };

  renderInput() {
    const { isUpdating, maxQuantity, minQuantity, className } = this.props;
    const { quantity } = this.state;

    return (
      <input
        // TODO SUBS: get rid of inline style (@see _quantityInput.scss), this's a temporary workaround for blinking
        style={STYLE_DISPLAY_INLINE_BLOCK}
        className={className}
        type="number"
        inputMode="numeric"
        disabled={isUpdating}
        min={minQuantity}
        max={maxQuantity}
        onClick={this.onFocus}
        onKeyPress={this.handleKeyPress}
        onChange={this.onChange}
        onBlur={this.handleQuantityInputBlur}
        value={quantity}
        ref={this.bindInput}
        aria-label="Quantity"
      />
    );
  }

  render() {
    const {
      isUpdating,
      productWarning,
      showButtons,
    } = this.props;
    const { quantity } = this.state;

    return (
      <div className="button-wrapper">
        <div className="quantityInput button-section quantity-non-zero">
          { showButtons && (
          <button
            onClick={this.decrease}
            disabled={quantity <= 0 || isUpdating}
            className="quantityInput__minus fop-btn-minus"
            aria-label="Remove from trolley"
          />
          )}
          {this.renderInput()}
          { showButtons && (
          <button
            onClick={this.increase}
            disabled={productWarning || isUpdating}
            className="quantityInput__plus fop-btn-add fop-btn-add-single fop-btn-plus"
            aria-label="Add to trolley"
          />
          )}
        </div>
      </div>
    );
  }
}
